import * as UserActions from '../actions/user.actions';
import * as UserState from '../states/user.state';

export class State extends UserState.State { }

const initialState: UserState.State = UserState.initialState;

/**
 *
 *
 * @export
 * @param {*} [state=initialState]
 * @param {UserActions.Actions} action
 * @returns {UserState.State}
 */
export function reducer(state = initialState, action: UserActions.Actions): UserState.State {
	switch (action.type) {

		case UserActions.ActionTypes.LOADING:
			state = Object.assign({}, state, 
			{ loading: action.payload !== null &&  action.payload !== undefined ? action.payload : true });
			return state;
		case UserActions.ActionTypes.PUT_LOGGED_IN:
			state = Object.assign({}, state, { loading: false, logged_in: action.payload, login_cancel: false });
			return state;
		case UserActions.ActionTypes.PUT_USER_INFO:
			state = Object.assign({}, state, { loading: false, user_info: action.payload, logged_in: !!action.payload, login_cancel: false });
			return state;
		case UserActions.ActionTypes.PUT_USER_PNRS:
			state = Object.assign({}, state, { 
				loading: false, 
				user_pnrs: action.payload ? action.payload.pnrs : null, 
				user_pnr_translation: action.payload ? action.payload.translate : null, 
				logged_in: !!action.payload, 
				login_cancel: false });
			return state;
		case UserActions.ActionTypes.PUT_CANCEL_LOGIN:
			state = Object.assign({}, state, { loading: false, logged_in: false, login_cancel: action.payload });
			return state;
		case UserActions.ActionTypes.PUT_COUNTRY:
			state = Object.assign({}, state, { loading: false, country: action.payload });
			return state;
		case UserActions.ActionTypes.PUT_MARKET:
			state = Object.assign({}, state, { loading: false, market: action.payload });
			return state;
		case UserActions.ActionTypes.PUT_LANGUAGE:
			state = Object.assign({}, state, { loading: false, language: action.payload });
			return state;
		// case UserActions.ActionTypes.PUT_FALLBACK_HEADER:
		// 	state = Object.assign({}, state, { fallback_header: action.payload });
		// 	return state;
		case UserActions.ActionTypes.PUT_CONFIRM_DIALOG:
			state = Object.assign({}, state, { confirm_dialog_open: action.payload });
			return state;
		case UserActions.ActionTypes.PUT_IS_CORPORATE:
			state = Object.assign({}, state, { is_corporate: action.payload });
			return state;
		case UserActions.ActionTypes.PUT_EXTEND_SESSION:
			state = Object.assign({}, state, { extendSession: action.payload });
			return state;
		case UserActions.ActionTypes.PUT_USER_POINTS:
			const updatedUserInfoState = Object.assign({}, state.user_info, { currentPoints: action.payload });
			state = Object.assign({}, state, { user_info: updatedUserInfoState });
			return state;
		case UserActions.ActionTypes.PUT_MARKET_LOADING:
			state = Object.assign({}, state, { is_market_loading: action.payload});
			return state;
		case UserActions.ActionTypes.PUT_DEEPLINK_MARKET:
			state = Object.assign({}, state, { deeplink_market: action.payload });
			return state;
		case UserActions.ActionTypes.RESET:
			state = Object.assign({}, state, initialState);
			return state;
		default:
			return state;
	}
}

export const getLoading = (state: UserState.State) => state.loading;
export const getLoggedIn = (state: UserState.State) => state.logged_in;
export const getUserInfo = (state: UserState.State) => state.user_info;
export const getLoginCancel = (state: UserState.State) => state.login_cancel;
export const getUserCountry = (state: UserState.State) => state.country;
export const getUserMarket = (state: UserState.State) => state.market;
export const getUserLanguage = (state: UserState.State) => state.language;
export const getFallbackHeader = (state: UserState.State) => state.fallback_header;
export const getConfirmDialog = (state: UserState.State) => state.confirm_dialog_open;
export const getIsCorporate = (state: UserState.State) => state.is_corporate;
export const getExtendSession = (state: UserState.State) => state.extendSession;
export const getMarketLoading = (state: UserState.State) => state.is_market_loading;
export const getUserPNRs = (state: UserState.State) => { 
	return { 'pnrs': state.user_pnrs, 'translate': state.user_pnr_translation }; 
};
export const getDeeplinkMarket = (state:UserState.State)=>state.deeplink_market;
